/**
 * Node modules
 */
import styled from 'styled-components';

/**
 * Private modules
 */
import { scale } from '../.private';

/**
 * Private functions
 */
const getStyles = (props) => {
  const { mode } = props;
  const styles = [];
  switch (mode) {
    case 'amount': {
      styles.push('color: rgba(247, 140, 108, 1);');
      break;
    }
    case 'date': {
      styles.push('color: rgba(130, 170, 255, 1);');
      break;
    }
    case 'game': {
      styles.push('color: rgba(130, 170, 255, 1);');
      break;
    }
    case 'end': {
      styles.push('color: rgba(130, 170, 255, 1);');
      break;
    }
    case 'number': {
      styles.push('color: rgba(195, 232, 141, 1);');
      break;
    }
    case 'special': {
      styles.push('color: rgba(255, 203, 107, 1);');
      break;
    }
    default: {
      styles.push('color: rgba(236, 240, 241, 1);');
      break;
    }
  }
  return styles.join('');
};
export default styled.span`
  /* stylelint-disable */
  ${getStyles};
  /* stylelint-enable */
  align-items: center;
  display: flex;
  height: ${scale.minor(8)}px;
`;
